import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { BlockSupplierComponent } from "./block-supplier.component";
import { MatTableModule } from "@angular/material/table";
import { QuotationQuotationsResourceModule } from 'libraries/service/resources/quotation-quotations/quotation-quotations-resource.module';
import { AutocompleteModule } from 'libraries/module/formbuilder/fields/autocomplete/autocomplete.module';
import { FormsModule } from '@angular/forms';
import { ClickOutsideModule } from 'libraries/ui_clickOutside/clickOutside.module';
import { ErrorTracingModule } from 'libraries/service/error-tracing/error-tracing.module';

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        QuotationQuotationsResourceModule,
        AutocompleteModule,
        ClickOutsideModule,
        FormsModule,
        ErrorTracingModule,
    ],
    exports: [BlockSupplierComponent],
    declarations: [BlockSupplierComponent],
    providers: [],
})
export class BlockSupplierModule { }
